var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:document-16-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 1.5V5C8.5 5.39782 8.65804 5.77936 8.93934 6.06066C9.22064 6.34196 9.60218 6.5 10 6.5H13.5V14C13.5 14.3978 13.342 14.7794 13.0607 15.0607C12.7794 15.342 12.3978 15.5 12 15.5H5C4.60218 15.5 4.22064 15.342 3.93934 15.0607C3.65804 14.7794 3.5 14.3978 3.5 14V3C3.5 2.60218 3.65804 2.22064 3.93934 1.93934C4.22064 1.65804 4.60218 1.5 5 1.5H8.5ZM9.5 1.75V5C9.5 5.13261 9.55268 5.25979 9.64645 5.35355C9.74021 5.44732 9.86739 5.5 10 5.5H13.25L9.5 1.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.b0432c11e670db72a4d0de0d003c3e4c.svg";
export { ForwardRef as ReactComponent };